import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string, object, bool, func } from 'prop-types';
import { RecommendationsPlaceholder, RecommendationsProvider } from '@thd-olt-component-react/recommendations';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { NoResultsFoundBanner } from '@thd-olt-component-react/no-results-found-banner';
import { Row, Col } from '@thd-olt-component-react/grid';
import { RelatedSearch } from '@thd-olt-component-react/related-search';
import { ShopByCategory } from '@thd-olt-component-react/shop-by-category';

const NoResultsFound = ({ keyword, recommendationsCtx, cpoOnly, onCpoClick }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('no-results-found.ready'); }, []);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  let searchCookie = '';
  if (typeof window !== 'undefined') {
    searchCookie = window.cookieUtils?.readBrowserCookie('x-ttsearch') || '';
  }
  const searchOptions = searchCookie.split(',');
  const enableExtraComponents = searchOptions.filter((opt) => opt === 'nrf').length === 1;

  const crumbs = [
    { label: 'Text Search', url: '' },
    { label: keyword, url: `/s/${keyword}?NCNI-5` }
  ];

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('search.no-results', { searchReport: { keyword } });
      LIFE_CYCLE_EVENT_BUS.trigger('no-results.loaded', { keyword });
    }
  }, []);

  return (
    <RecommendationsProvider resx={recommendationsCtx}>
      <Row className="isBound">
        <Col xs="12" sm="12" md="12">
          <Breadcrumbs staticCrumbs={crumbs} hideOnNoCategory={isMobile} />
          <NoResultsFoundBanner keyword={keyword} cpoOnly={cpoOnly} onCpoClick={onCpoClick} />
          {enableExtraComponents && (
            <>
              <RelatedSearch recent limitItems />
              <ShopByCategory />
              <RecommendationsPlaceholder scheme="rv_search_plp_rr" />
            </>
          )}
        </Col>
      </Row>
    </RecommendationsProvider>
  );
};

NoResultsFound.displayName = 'NoResultsFound';

NoResultsFound.propTypes = {
  keyword: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  recommendationsCtx: object.isRequired,
  cpoOnly: bool,
  onCpoClick: func
};

NoResultsFound.defaultProps = {
  cpoOnly: false,
  onCpoClick: () => {},
};

export { NoResultsFound };